import { decode } from 'he';

function isHtmlEncoded(str) {
  return /&(?:#x?[\dA-Fa-f]+|[a-z]+);/.test(str);
}

function safeDecode(str) {
  return isHtmlEncoded(str) ? decode(str) : str;
}

export default safeDecode;